import React, { useState } from "react";
import { GisMapWrapper } from "@gis/GisMapWrapper";
import GenericMarker from "@gis/components/GenericMarker";
import MarkerLocation from "@gis/assets/images/logo/noc-green-marker.svg";
import LocationMarker from "@gis/components/LocationMarker";
import { nocLocationElement } from "@gis/components/overlayElements";

interface MapPanelProps {
    coordinates: {
        longitude: string | number;
        latitude: string | number;
    };
    chainages: string;
}

const MapPanel = React.memo(({ coordinates, chainages }: MapPanelProps) => (
    <div style={{ width: "100%", height: "400px" }}>
        <GisMapWrapper center={[coordinates?.longitude, coordinates?.latitude]} zoom={15}>
            {(coordinates?.longitude !== 0 && coordinates?.latitude !== 0) && (
                <>
                    <GenericMarker
                        coordinates={[
                            Number(coordinates?.longitude) || 0,
                            Number(coordinates?.latitude) || 0,
                        ]}
                        size={0.5}
                        anchor={[0.5, 1]}
                        img={MarkerLocation}
                    />

                    <LocationMarker
                        coordinates={[
                            Number(coordinates?.longitude) || 0,
                            Number(coordinates?.latitude) || 0,
                        ]}
                        html={
                            nocLocationElement(coordinates?.latitude.toString() || '0',
                                coordinates?.longitude.toString() || '0',
                                chainages,
                                'startLocation')}
                    />

                </>
            )}
        </GisMapWrapper>
    </div>
));

export default MapPanel;